import React, { Component } from 'react'

import _ from 'lodash/fp'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'

import { actions, selectors as claimTokensSelectors } from '../../reducers/claimTokens'

import Button from '@material-ui/core/Button'

import colors from '@fe/ui/colors'

import Scorecard from './Scorecard'

const enhance = _.flow(
  connect(
    (s, p) => {
      const loggedIn = Boolean(_.get('auth.token', s))
      const claimWaiting = _.get('claimTokens.claimRequestWaiting', s)
      const claimSuccess = Boolean(_.get('claimTokens.claimSuccessAt', s))
      const claimError = Boolean(_.get('claimTokens.claimErrorAt', s))
      const disabled = !loggedIn || claimSuccess || claimWaiting

      const claimToken = _.get('match.params.token', p)
      const gameId = claimTokensSelectors.getGameIdFromToken(claimToken)(s)

      return {
        loggedIn,
        claimWaiting,
        claimSuccess,
        claimError,
        disabled,
        gameId
      }
    },
    (d, p) => {
      const claimToken = _.get('match.params.token', p)
      return {
        loadMatchRequest: () => d(actions.loadMatchRequest({ claimToken })),
        claim: () => d(actions.claimRequest({ claimToken }))
      }
    }
  )
)

class Claim extends Component {
  UNSAFE_componentWillMount () {
    this.props.loadMatchRequest()
  }

  render () {
    const { gameId, loggedIn, claimSuccess, claimError, disabled, claim, match: { params: { token } } } = this.props

    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100vh'
        }}
      >
        <h1>You have been sent a game!</h1>

        <p>Add this game to your GLFR account by logging in below or creating a new user!</p>

        {Boolean(gameId) && (
          <Scorecard gameId={gameId} />
        )}

        {
          loggedIn
            ? (
              <Button
                raised
                icon='add'
                style={{
                  backgroundColor: colors.primaryDarkGreen,
                  color: colors.white
                }}
                onClick={claim}
                disabled={disabled}
              >
                Add this game to your account
              </Button>
              )
            : (
              <Link
                to={`/login?returnTo=/claim/${token}`}
              >
                <Button
                  raised
                  icon='add'
                  disabled={disabled}
                  style={{
                    backgroundColor: colors.primaryDarkGreen,
                    color: colors.white
                  }}
                >
                  Add this game to your account
                </Button>
              </Link>
              )
        }

        {claimSuccess && (
          <div
            style={{ padding: 15, marginTop: 15, color: 'white', backgroundColor: colors.lightGreen }}
          >
            Game added! Download the <a style={{ textDecoration: 'underline' }} href='http://www.glfr.com'>GLFR app</a> to see more details about the game.
          </div>
        )}
        {claimError && (
          <div
            style={{ padding: 15, marginTop: 15, color: 'white', backgroundColor: colors.primaryDarkRed }}
          >
            <p>Could not add the game. Check that the game has not already been added by you or someone else.</p>
            <p>You can also contact <a style={{ textDecoration: 'underline' }} href='http://ingeniumgolf.com/support/'>Ingenium Golf Support</a> with your token <b>{token}</b> if you believe this is an error.</p>
          </div>
        )}
      </div>
    )
  }
}

export default enhance(Claim)
